import {
  PaymentMethod,
  PaymentMethodState,
  PaymentMethodType,
  RenewalState,
} from "apps-common/types";

import { routes } from "../routes";

import { getPaymentMethodStatus, isRenewAllowed } from "./member";

type PaymentDetailTextColor = "grayLight" | "lightRed";
interface PaymentDetail {
  value: string;
  color: PaymentDetailTextColor;
}

export const formatCardNumber = (cardNumber: string): string => {
  // Add spaces between every 4 characters: "********4111" => "**** **** 4111"
  const match = cardNumber.match(/.{1,4}/g);
  if (!match) return "";
  return match.join(" ");
};

export const paymentMethodDetail = (
  paymentMethod: PaymentMethod,
): PaymentDetail[] => {
  const paymentMethodState = getPaymentMethodStatus(paymentMethod);
  const paymentDetailsText =
    paymentMethod.type === PaymentMethodType.CreditCard
      ? formatCardNumber(paymentMethod.cardNumber)
      : "PayPal";
  const paymentDetails = [
    { value: paymentDetailsText, color: "grayLight" as PaymentDetailTextColor },
  ];

  if (paymentMethodState === PaymentMethodState.EXPIRED) {
    paymentDetails.push({
      value: "Expired",
      color: "lightRed" as PaymentDetailTextColor,
    });
  }

  return paymentDetails;
};

interface PaymentMethodCTAText {
  lokaliseLabelKeyName: string;
  track: { cta: string };
  href: string;
  color?: "blueLight" | "lightRed";
}

// TODO remove prepaidFlag after 100% prepaid rollout
export const getToPaymentPageCTAText = (
  renewalState: RenewalState,
  paymentMethod: PaymentMethod | undefined,
  prepaidFlag: boolean,
): PaymentMethodCTAText => {
  const isRenewFlow = isRenewAllowed(renewalState);
  const toPaymentMethodPage = paymentMethod
    ? routes.reviewPaymentMethod
    : routes.updateAddressInfo;

  if (isRenewFlow) {
    return {
      lokaliseLabelKeyName: "membership_hub_renew_membership",
      track: { cta: "renew_membership" },
      href: toPaymentMethodPage,
      color: "lightRed",
    };
  }

  // normal flow
  const toExistingPaymentPagekeyName = prepaidFlag
    ? "membership_hub_view_payment_details_page"
    : "membership_hub_update_payment_method";
  const AddOrUpdatePaymentMethodText = paymentMethod
    ? toExistingPaymentPagekeyName
    : "membership_hub_add_payment_method";
  return {
    lokaliseLabelKeyName: AddOrUpdatePaymentMethodText,
    track: paymentMethod
      ? { cta: "view_payment" }
      : { cta: "add_payment_method" },
    href: toPaymentMethodPage,
    color: "blueLight",
  };
};
